/**
 * @fileoverview 特集に紐づく記事のバックナンバーの行レイアウトコンポーネント
 */
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { cardCommonProps } from '@/components/_parials/contentsCard'
import ContentsCard from '@/components/contents/ContentsCard.vue'

export default defineComponent({
  name: 'LayoutBackNumberReportCardRows',

  components: {
    ContentsCard,
  },

  props: {
    ...cardCommonProps,

    /**
     * コンテンツ情報の配列
     */
    items: {
      type: Array as PropType<ReportItem[]>,
      required: true,
    },

    /**
     * 見出しのオプション
     */
    headingOptions: {
      type: Object as PropType<{
        // HTML 要素名
        tagName?: keyof HTMLElementTagNameMap,

        // CSS の line-height 値
        lineHeight?: number,

        // CSS の font-size
        fontSize?: {
          pc: string,
          sp: string,
        },

        // 文字の太さ
        fontWeight?: 'normal' | 'bold',

        // 表示最大行数
        maxLine?: number,
      }>,
      default: () => ({
        maxLine: 2,
      }),
    },
  },
})
</script>

<template>
  <div
    v-if="items.length"
    class="o-list__backNumberReportCard">
    <ul class="o-list__backNumberReportCard--items">
      <li
        v-for="(item) in items"
        :key="item.id"
        class="o-list__backNumberReportCard--item">
        <ContentsCard
          :item="item"
          :has-hero="hasHero"
          :highlight-word="highlightWord"
          :size="size"
          :heading-options="headingOptions"
          :image-options="imageOptions"
          :horizontal="{ pc: true, sp: true }" />
      </li>
    </ul>
  <!-- /.o-list__backNumberReportCard --></div>
</template>

<style lang="sass" scoped>
.o-list__backNumberReportCard
  $margin-px: 24
  margin-top: changeSizePx2Em($margin-px)

  &:first-child
    margin-top: 0

  & &--item
    margin-top: changeSizePx2Em($margin-px)

    &:first-child
      margin-top: 0
</style>
